import { render, staticRenderFns } from "./UpdateScheduledTemplateType.vue?vue&type=template&id=4ff8c8bf&"
import script from "./UpdateScheduledTemplateType.vue?vue&type=script&lang=js&"
export * from "./UpdateScheduledTemplateType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports